export { default as CardUserDetails } from './CardUserDetails';
